import api from './api';

const editorService = {
  createProject: (data) =>
    api.post('/api/v1/editor/projects', data).then((r) => r.data.data),

  getProject: (id) =>
    api.get(`/api/v1/editor/projects/${id}`).then((r) => r.data.data),

  updateProject: (id, data) =>
    api.put(`/api/v1/editor/projects/${id}`, data).then((r) => r.data.data),

  deleteProject: (id) =>
    api.delete(`/api/v1/editor/projects/${id}`),

  listProjects: (params) =>
    api.get('/api/v1/editor/projects', { params }).then((r) => r.data.data),

  getSourceUploadUrl: (id) =>
    api.post(`/api/v1/editor/projects/${id}/source-upload-url`).then((r) => r.data.data),

  getExportUrl: (id) =>
    api.post(`/api/v1/editor/projects/${id}/export-url`).then((r) => r.data.data),

  markExportComplete: (id, editedS3Key, fileSizeBytes) =>
    api.put(`/api/v1/editor/projects/${id}/export-complete`, null, {
      params: { editedS3Key, fileSizeBytes },
    }).then((r) => r.data.data),

  sendToContent: (id) =>
    api.post(`/api/v1/editor/projects/${id}/to-content`).then((r) => r.data.data),
};

export default editorService;
